import { Box, Stack } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import ChatSkeleton from "../../components/ChatSkeleton";
import { useGetState } from "../../context/useGetState";

import { ChatFeed } from "./ChatFeed";
import MessageBox from "./MessageBox";
import WelcomeChat from "./WelcomeChat";
import { getMessages } from "./service";
import axios from "axios";
import { useParams } from "react-router";

function ChatArea({
  socket,
  currentChat,
  handleSendMsg,
  handleSendFile,
  typingUserId,
  accountType,
  privateChatRecipient,
  chatContext,
  messages,
  loading,
  ...props
}) {
  const { state } = useGetState();
  const loggedInUser = state?.userInfo

  const ref = useRef(null);
  const { privateUserId } = useParams();
  const [parentWidth, setParentWidth] = useState(0);
  const [messagesPrivateChatRecipient, setMessagesPrivateChatRecipient] = useState([]);
  useEffect(() => {
    const chatAreaElement = document.getElementsByClassName("chat-area")[0];
  
    if (chatAreaElement) {
      setParentWidth(chatAreaElement.offsetWidth);
  
      const resize = () => {
        setParentWidth(chatAreaElement.offsetWidth);
      };
  
      const resizeObserver = new ResizeObserver((entries) => {
        resize();
      });
  
      resizeObserver.observe(chatAreaElement);
    }
  }, []);  
    return loading && privateUserId === undefined && currentChat === undefined ?  (
    <WelcomeChat className="chat-area" />
    
  ) : (
    <Stack
      className="chat-area scroll-container"
      position={"relative"}
      p="10px"
      height={[window.innerHeight - 300, window.innerHeight - 100]}
      maxH={["unset", window.innerHeight - 250]}
      overflowY={"scroll"}
      ref={ref}
      spacing="20px"
      bg="transparent !important"
    >
      {messages && messages?.map((message, key) => {
          return (
            <ChatFeed
              message={message}
              key={key}
              chatContext={chatContext}
              state={state}
              {...props}
            />
          );
        })}
      <Box mt="50px !important" />
      <MessageBox
        handleSendMsg={handleSendMsg}
        handleSendFile={handleSendFile}
        socket={socket}
        currentChat={currentChat}
        typingUserId={typingUserId}
        width={parentWidth}
        accountType={accountType}
        privateChatRecipient={privateChatRecipient}
        {...props}
      />
    </Stack>
  );
}

export default ChatArea;
